import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于草民影院的常见问题，快速了解如何使用
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer select-none list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}